import countries from "../const/countries";

export const month = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export function isProductionEnvironment() {
  return ["production", "staging"].includes(import.meta.env.MODE);
}

export function getCountryName(countryCode: string) {
  return countries.find(({ code }) => countryCode === code.toLowerCase())?.name;
}

export function formatShortDate(unixTimestamp: number) {
  const date = new Date(unixTimestamp);
  return `${date.getDate()} ${month[date.getMonth()]}`;
}
export function formatMediumDate(unixTimestamp: number) {
  const date = new Date(unixTimestamp);
  return `${month[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
}
export function formatFullDate(unixTimestamp: number) {
  const date = new Date(unixTimestamp);
  return `${date.toUTCString()}`;
}